module.exports = __webpack_public_path__ + "static/media/backoffice.fea8c0bd.svg";